import { useCurrentPublicCampaign } from '../campaign';

export const useExperienceById = (id: string) => {
  const { experiences, loading } = useCurrentPublicCampaign();

  const experience = experiences?.find(experience => experience.id === id);

  return { experience, loading };
};
